export class FlashcardManager {
  constructor(cards, coursenum, pageSessionKey, eventCategory, eventFeatures) {
    this.allCards = cards
    this.currentCards = cards.slice()
    this.faceDown = false
    this.displayFilterForm = false
    this.coursenum = coursenum
    this.pageSessionKey = pageSessionKey
    this.eventCategory = eventCategory
    this.eventFeatures = eventFeatures
  }

  start() {
    this.renderNextCard()
    this.attachHandlers()
  }

  attachHandlers() {
    $('#next_card').on('click', () => {
      if (this.currentCards.length > 0) {
        this.renderNextCard()
      }
    })

    $('#flip').on('click', () => {
      this.faceDown = !this.faceDown
      $('.card').toggleClass('applyflip')
      $('.cardFront').attr('aria-hidden', this.faceDown ? 'true' : 'false')
      $('.cardBack').attr('aria-hidden', this.faceDown ? 'false' : 'true')
    })

    $('#form_tab')
      .off()
      .on('click', () => {
        this.toggleFilterFormDisplay()
      })

    $('#form').on('submit', event => {
      event.preventDefault()
      this.toggleFilterFormDisplay()
      this.currentCards = filterChapter(
        this.allCards,
        $('#id_select_chapter').val(),
        $('input[name="option"]:checked').val()
      )
      this.renderNextCard()
    })
  }

  renderNextCard() {
    var card = popRandomItem(this.currentCards)
    renderCard(card)
    resizeCard(card)

    if (this.faceDown) {
      this.faceDown = false
      $('.card').toggleClass('applyflip')
      $('.cardFront').attr('aria-hidden', this.faceDown ? 'true' : 'false')
      $('.cardBack').attr('aria-hidden', this.faceDown ? 'false' : 'true')
    }

    $('#next_card').removeAttr('disabled')
    if (this.currentCards.length === 0) {
      $('#next_card').attr('disabled', 'disabled')
    }
  }

  toggleFilterFormDisplay() {
    $('#form_filter').slideToggle(400, () => {
      $('#id_option_0').trigger('focus')
    })

    $('#form_tab_arrow').attr(
      'class',
      this.displayFilterForm ? 'icon icon_arrow_down' : 'icon icon_arrow_up'
    )
    $('#form_tab_container').toggleClass('line_across')

    $('#form_tab').attr('aria-expanded', String(!this.displayFilterForm))

    this.displayFilterForm = !this.displayFilterForm
  }
}

function renderCard(card) {
  if (!card) return
  $('.cardFront').html(card.term)
  $('.cardBack').html(card.definition)
}

function filterChapter(startingCards, chapter, cardOption) {
  var nextCards = startingCards.slice()
  if (chapter !== 'all') {
    nextCards = nextCards.filter(c => c.chapter === chapter)
  }

  switch (cardOption) {
    case 'both':
      return nextCards
    case 'user':
      return nextCards.filter(c => c.userCreated)
    default:
      return nextCards.filter(c => !c.userCreated)
  }
}

function popRandomItem(list) {
  var index = Math.floor(Math.random() * list.length)
  var result = list.splice(index, 1).pop()
  return result
}

function resizeCard(card) {
  if (!card) return
  var frontNumWords = card.term.split(' ').length

  if (frontNumWords === 1 && card.term.length > 50) {
    $('.cardFront').css({ 'font-size': '18px', padding: '20px 15px 15px 15px' })
  } else {
    if (frontNumWords >= 1 && frontNumWords < 10) {
      $('.cardFront').css({ 'font-size': '36px', 'padding-top': '100px' })
    } else if (frontNumWords >= 10 && frontNumWords < 15) {
      $('.cardFront').css({ 'font-size': '28px', 'padding-top': '80px' })
    } else if (frontNumWords >= 15 && frontNumWords < 20) {
      $('.cardFront').css({ 'font-size': '28px', 'padding-top': '55px' })
    } else if (frontNumWords >= 20 && frontNumWords < 30) {
      $('.cardFront').css({ 'font-size': '22px', 'padding-top': '60px' })
    } else if (frontNumWords >= 30 && frontNumWords < 50) {
      $('.cardFront').css({ 'font-size': '18px', 'padding-top': '60px' })
    } else {
      $('.cardFront').css({ 'font-size': '12px', 'padding-top': '15px' })
    }
  }

  var numWords = card.definition.split(' ').length

  if (numWords === 1 && card.definition.length > 50) {
    $('.cardBack').css({ 'font-size': '18px', padding: '20px 15px 15px 15px' })
  } else {
    if (numWords >= 1 && numWords < 10) {
      $('.cardBack').css({ 'font-size': '30px', 'padding-top': '100px' })
    } else if (numWords >= 10 && numWords < 15) {
      $('.cardBack').css({ 'font-size': '28px', 'padding-top': '80px' })
    } else if (numWords >= 15 && numWords < 20) {
      $('.cardBack').css({ 'font-size': '28px', 'padding-top': '55px' })
    } else if (numWords >= 20 && numWords < 30) {
      $('.cardBack').css({ 'font-size': '22px', 'padding-top': '60px' })
    } else if (frontNumWords >= 30 && frontNumWords < 50) {
      $('.cardBack').css({ 'font-size': '18px', 'padding-top': '15px' })
    } else {
      $('.cardBack').css({ 'font-size': '12px', 'padding-top': '15px' })
    }
  }
}
